import * as React from 'react';
import Loadable from 'react-loadable';
import { FormGroup } from 'reactstrap';
import { FieldRenderProps } from 'react-final-form';
import { InputProps, ValidationMessages } from '.';
import FieldLabel from './FieldLabel';
import Loading from 'components/shared/Loading';
import { localMoment } from 'util/Time';
import { useState, useEffect } from 'react';
import classnames from 'classnames';

const SingleDatePicker = Loadable({
	loader: () =>
		import(/* webpackChunkName: "single-date-picker-component" */ 'react-dates/lib/components/SingleDatePicker'),
	loading: Loading,
});

/**
 * Component used to handle dates in forms (no time)
 *
 * @class DatePicker
 * @extends {(React.Component<FieldRenderProps & InputProps>)}
 */
export default function DateOnly(
	props: FieldRenderProps<any, HTMLInputElement> & InputProps & { isOutsideRange?: () => boolean },
) {
	const [focused, setFocused] = useState(false);
	const [date, setDate] = useState<any>(null);

	useEffect(() => {
		setDate(props.input.value ? localMoment(props.input.value) : null);
	}, [props.input.value]);

	const {
		input: { name, onChange },
		meta,
		indicateDirty,
	} = props;

	return (
		<FormGroup className={classnames('form-group--date', { 'form-group--dirty': indicateDirty && meta.dirty })}>
			<FieldLabel {...props} htmlFor={name} />

			<SingleDatePicker
				{...props}
				id={name}
				showDefaultInputIcon
				showClearDate
				small
				disabled={props.disabled}
				date={date}
				focused={focused}
				onDateChange={(date) => {
					setDate(date);
					onChange(date);
				}}
				onFocusChange={({ focused }) => {
					setFocused(!!focused);
				}}
				isOutsideRange={props.isOutsideRange}
			/>

			<ValidationMessages meta={meta} id={name} />
		</FormGroup>
	);
}
